import React from 'react';
import type PlanSettingsSavedViewsType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/saved-views/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';

/**
 * Plan Settings - saved-views page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsSavedViews = lazyForPaint<typeof PlanSettingsSavedViewsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-saved-views", jiraSpaEntry: "async-plan-settings-saved-views" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/saved-views'
			),
		),
	{ ssr: false },
);

const AsyncPlanSettingsSavedViews = (): React.JSX.Element => (
	<LazyPage
		Page={LazyPlanSettingsSavedViews}
		pageId="plan-settings-saved-views"
		shouldShowSpinner={!fg('plan_settings_refresh')}
	/>
);

export default AsyncPlanSettingsSavedViews;
